import React, { useEffect } from 'react'
import Container from "../../components/Container/Container"
import Document from '../../components/Documents/Document'
import { getDocument, userSelector } from '../../services/reduxSlices/UserSlice';
import { useDispatch, useSelector } from 'react-redux';

/**
 * Page du menu Boite de reception --> Document en attente de signature
 * @returns SignDocs
 */
export default function InProgressDocument() {

  const FilterInProgressDoc = (data) => {
    const inProgressDocs = data.filter((doc) => doc.statut === 'en_cours')
    return inProgressDocs
  }

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getDocument())
  }, [])

  const { signDocuments } = useSelector(userSelector)

  useEffect(() => {
    let script = document.createElement("script")
    script.src = "./assets/js/scripts.bundle.js"
    document.body.appendChild(script)
  }, [])

  return (
    <Container>
      {
        signDocuments.data &&
        <>
          <h1 style={{ color: 'wheat', fontWeight: '700' }}>Document en cour de signature  ({FilterInProgressDoc(signDocuments.data).length})</h1>
          <Document data={FilterInProgressDoc(signDocuments.data)} />
        </>
      }
    </Container>
  )
}
